import { apiService } from "../axiosService";

export const getBuilderUsersApi = async ({ search, page, limit, signal }) => {
  const response = await apiService.get("/users", {
    params: { search, page, limit },
    signal
  });
  return response;
};

export const getBuilderUserByIdApi = async (id) => {
  const response = await apiService.get(`/user/${id}`);
  return response;
};

export const createBuilderUserApi = async (payload) => {
  const response = await apiService.post("/user", payload);
  return response;
};

export const updateBuilderUserApi = async (id, payload) => {
  const response = await apiService.put(`/user/${id}`, payload);
  return response;
};

export const deleteBuilderUserApi = async (id) => {
  const response = await apiService.delete(`/user/${id}`);
  return response;
};

export const getRolesApi = async () => {
  const response = await apiService.get("/roles");
  return response;
};
export const createRoleApi = async (payload) => {
  const response = await apiService.post("/roles", payload);
  return response;
};

export const updateRoleApi = async (id, payload) => {
  const response = await apiService.put(`/roles/${id}`, payload);
  return response;
};

export const deleteRoleApi = async (id) => {
  const response = await apiService.delete(`/roles/${id}`);
  return response;
};
